import { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

export const fleetRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () =>
      import('./management/VehicleManagementRoute').then((m) => ({
        Component: m.VehicleManagementRoute,
      })),
  },
  {
    path: 'inspections',
    lazy: () =>
      import('./inspection/VehicleInspectionsRoute').then((m) => ({
        Component: m.VehicleInspectionsRoute,
      })),
  },
  {
    path: 'credentials',
    lazy: () =>
      import('./credentials/VehicleCredentialsRoute').then((m) => ({
        Component: m.VehicleCredentialsRoute,
      })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute routePath="/fleet" linkText="Go back to fleet" />
    ),
  },
];
